module.exports = function SharedWorkerWrapper(name) {
  return new SharedWorker(__webpack_public_path__ + "worker.7179aa1afb041f81e74d.js", name);
};